/**
 * Vista: Marcas y fabricantes (ERP F1, B1 · diseño §2.5)
 * Separados de las líneas, como trabaja Jorge. Una marca nueva (URREA, KELLY…) NO toca el enum viejo.
 * Patrón de 2 pestañas: «Consultar» (las dos listas) y «Agregar / editar» (los dos formularios).
 */

import catalogos from '../../services/erpCatalogos.service.js';
import permisos from '../../services/permissions.service.js';
import modal from '../../utils/modal.js';
import toast from '../../utils/toast.js';
import { esc, errMsg, estadoBadge, subirAlFormulario, val } from './erpUi.js';
import { permisosPantalla, pestanasHtml, Pestanas } from '../../utils/pestanasErp.js';

export default {
  data: { marcas: [], fabricantes: [], editMarca: null, editFab: null, verBajas: false },

  async render() {
    const pp = permisosPantalla('marcas');
    const arriba = `
      <div class="erp-aviso erp-aviso-info">
        La <strong>marca</strong> es lo que dice el producto (GREEN DROP); el <strong>fabricante</strong> es quien lo hace (CHINADRIP).
        Las marcas marcadas «catálogo original» las usa también el sistema actual (tractores, modelos): se pueden editar y desactivar, no dar de baja.
      </div>`;
    const formulario = `
      <div class="erp-dos-col">
          <div class="card erp-form-card" id="marcaFormCard">
            <div class="card-header"><h2 class="card-title" id="marcaFormTitulo">Nueva marca</h2></div>
            <form id="marcaForm" autocomplete="off">
              <div class="form-row">
                <div class="form-group">
                  <label>Nombre *</label>
                  <input type="text" id="ma_nombre" class="form-control" maxlength="80" required placeholder="Ej: URREA" />
                </div>
                <div class="form-group">
                  <label>Código</label>
                  <input type="text" id="ma_codigo" class="form-control" maxlength="20" placeholder="Se arma del nombre" style="text-transform:uppercase;" />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label>Fabricante</label>
                  <select id="ma_fabricante" class="form-control"><option value="">— Sin fabricante —</option></select>
                </div>
                <div class="form-group">
                  <label>Notas</label>
                  <input type="text" id="ma_notas" class="form-control" maxlength="250" />
                </div>
              </div>
              <div class="erp-acciones-form">
                <button type="button" class="btn btn-secondary" id="btnMarcaLimpiar">Cancelar</button>
                <button type="submit" class="btn btn-primary" id="btnMarcaGuardar">Guardar marca</button>
              </div>
            </form>
          </div>

          <div class="card erp-form-card" id="fabFormCard">
            <div class="card-header"><h2 class="card-title" id="fabFormTitulo">Nuevo fabricante</h2></div>
            <form id="fabForm" autocomplete="off">
              <div class="form-row">
                <div class="form-group">
                  <label>Nombre *</label>
                  <input type="text" id="fa_nombre" class="form-control" maxlength="150" required placeholder="Ej: CHINADRIP" />
                </div>
                <div class="form-group">
                  <label>País</label>
                  <input type="text" id="fa_pais" class="form-control" maxlength="60" placeholder="Ej: China" />
                </div>
              </div>
              <div class="form-group">
                <label>Notas</label>
                <input type="text" id="fa_notas" class="form-control" maxlength="250" />
              </div>
              <div class="erp-acciones-form">
                <button type="button" class="btn btn-secondary" id="btnFabLimpiar">Cancelar</button>
                <button type="submit" class="btn btn-primary" id="btnFabGuardar">Guardar fabricante</button>
              </div>
            </form>
          </div>
      </div>`;

    const consultar = `
      <div class="filters-card">
        <div class="filters-grid">
          <div class="form-group"><label>Buscar marca</label><input type="text" id="ma_buscar" class="form-control" placeholder="Nombre o código…" /></div>
          <div class="form-group" style="display:flex;align-items:flex-end;"><label class="erp-check"><input type="checkbox" id="mf_bajas" /> Ver dadas de baja</label></div>
        </div>
      </div>
      <div class="erp-dos-col">
        <section>
          <div class="card">
            <div class="card-header"><h2 class="card-title">Marcas</h2></div>
            <div class="table-container">
              <table class="table">
                <thead><tr><th>Marca</th><th>Fabricante</th><th class="tbl-hide-mobile">Uso</th><th>Estado</th><th style="text-align:right;">Acciones</th></tr></thead>
                <tbody id="marcasBody"><tr><td colspan="5" class="text-center"><div class="loading-spinner"></div></td></tr></tbody>
              </table>
            </div>
          </div>
        </section>

        <section>
          <div class="card">
            <div class="card-header"><h2 class="card-title">Fabricantes</h2></div>
            <div class="table-container">
              <table class="table">
                <thead><tr><th>Fabricante</th><th class="tbl-hide-mobile">País</th><th>Marcas</th><th>Estado</th><th style="text-align:right;">Acciones</th></tr></thead>
                <tbody id="fabBody"><tr><td colspan="5" class="text-center"><div class="loading-spinner"></div></td></tr></tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    `;
    return pestanasHtml({ id: 'mf', titulo: 'Marcas y fabricantes', ...pp, arriba, consultar, formulario });
  },

  async afterRender() {
    if (!permisos.canView('marcas')) {
      document.getElementById('content').innerHTML = '<div style="padding:2rem;text-align:center;"><h2>Acceso denegado</h2></div>';
      return;
    }
    window.currentView = this;
    this.data.editMarca = null;
    this.data.editFab = null;
    this.tabs = new Pestanas('mf', { alAgregar: () => { this.limpiarMarca(); this.limpiarFab(); } });
    document.getElementById('marcaForm')?.addEventListener('submit', (e) => { e.preventDefault(); this.guardarMarca(); });
    document.getElementById('fabForm')?.addEventListener('submit', (e) => { e.preventDefault(); this.guardarFab(); });
    document.getElementById('btnMarcaLimpiar')?.addEventListener('click', () => { this.limpiarMarca(); this.limpiarFab(); this.tabs.volver(); });
    document.getElementById('btnFabLimpiar')?.addEventListener('click', () => { this.limpiarMarca(); this.limpiarFab(); this.tabs.volver(); });
    document.getElementById('mf_bajas')?.addEventListener('change', (e) => { this.data.verBajas = e.target.checked; this.cargar(); });
    let t;
    document.getElementById('ma_buscar')?.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => this.renderMarcas(), 200); });
    await this.cargar();
  },

  async cargar() {
    try {
      const [rm, rf] = await Promise.all([
        catalogos.marcas.listar({ incluir_eliminadas: this.data.verBajas }),
        catalogos.fabricantes.listar({ incluir_eliminados: this.data.verBajas })
      ]);
      this.data.marcas = rm?.data?.marcas || [];
      this.data.fabricantes = rf?.data?.fabricantes || [];
      this.llenarSelectFabricantes();
      this.renderMarcas();
      this.renderFabricantes();
    } catch (err) {
      toast.error(errMsg(err, 'No se pudo cargar el catálogo'));
    }
  },

  llenarSelectFabricantes() {
    const sel = document.getElementById('ma_fabricante');
    if (!sel) return;
    const actual = sel.value;
    sel.innerHTML = '<option value="">— Sin fabricante —</option>' + this.data.fabricantes
      .filter((f) => !f.deleted_at && f.activo)
      .map((f) => `<option value="${f.id}">${esc(f.nombre)}</option>`).join('');
    sel.value = actual;
  },

  renderMarcas() {
    const body = document.getElementById('marcasBody');
    if (!body) return;
    const q = (document.getElementById('ma_buscar')?.value || '').toLowerCase();
    const lista = this.data.marcas.filter((m) => !q || m.nombre.toLowerCase().includes(q) || m.codigo.toLowerCase().includes(q));
    if (!lista.length) { body.innerHTML = '<tr><td colspan="5" class="text-center text-muted" style="padding:1.5rem;">Sin marcas.</td></tr>'; return; }
    body.innerHTML = lista.map((m) => `
      <tr ${!m.activo || m.deleted_at ? 'style="opacity:.6;"' : ''}>
        <td><strong>${esc(m.nombre)}</strong> <code style="font-size:.7rem;">${esc(m.codigo)}</code>
          ${m.enum_legacy ? '<div><span class="erp-chip" title="La usa también el sistema actual">catálogo original</span></div>' : ''}</td>
        <td>${m.fabricante_nombre ? esc(m.fabricante_nombre) : '<span class="text-muted">—</span>'}</td>
        <td class="tbl-hide-mobile" style="font-size:.8rem;">${m.productos} prod. · ${m.modelos} mod.</td>
        <td>${estadoBadge(m, { activo: 'Activa', inactivo: 'Inactiva' })}</td>
        <td style="text-align:right;white-space:nowrap;">
          ${m.deleted_at ? (permisos.canDelete('marcas') ? `<button class="btn-icon btn-success" title="Restaurar" onclick="window.currentView.restaurarMarca(${m.id})">↩️</button>` : '') : `
            ${permisos.canEdit('marcas') ? `<button class="btn-icon btn-edit" title="Editar" onclick="window.currentView.editarMarca(${m.id})">✏️</button>
              <button class="btn-icon ${m.activo ? 'btn-warning' : 'btn-success'}" title="${m.activo ? 'Desactivar' : 'Activar'}" onclick="window.currentView.toggleMarca(${m.id})">${m.activo ? '⏸️' : '▶️'}</button>` : ''}
            ${permisos.canDelete('marcas') && !m.enum_legacy ? `<button class="btn-icon btn-danger" title="Dar de baja" onclick="window.currentView.bajaMarca(${m.id})">🗑️</button>` : ''}`}
        </td>
      </tr>`).join('');
  },

  renderFabricantes() {
    const body = document.getElementById('fabBody');
    if (!body) return;
    if (!this.data.fabricantes.length) { body.innerHTML = '<tr><td colspan="5" class="text-center text-muted" style="padding:1.5rem;">Sin fabricantes.</td></tr>'; return; }
    body.innerHTML = this.data.fabricantes.map((f) => `
      <tr ${!f.activo || f.deleted_at ? 'style="opacity:.6;"' : ''}>
        <td><strong>${esc(f.nombre)}</strong>${f.notas ? `<div class="text-muted" style="font-size:.75rem;">${esc(f.notas)}</div>` : ''}</td>
        <td class="tbl-hide-mobile">${f.pais ? esc(f.pais) : '<span class="text-muted">—</span>'}</td>
        <td>${f.marcas}</td>
        <td>${estadoBadge(f)}</td>
        <td style="text-align:right;white-space:nowrap;">
          ${f.deleted_at ? (permisos.canDelete('marcas') ? `<button class="btn-icon btn-success" title="Restaurar" onclick="window.currentView.restaurarFab(${f.id})">↩️</button>` : '') : `
            ${permisos.canEdit('marcas') ? `<button class="btn-icon btn-edit" title="Editar" onclick="window.currentView.editarFab(${f.id})">✏️</button>
              <button class="btn-icon ${f.activo ? 'btn-warning' : 'btn-success'}" title="${f.activo ? 'Desactivar' : 'Activar'}" onclick="window.currentView.toggleFab(${f.id})">${f.activo ? '⏸️' : '▶️'}</button>` : ''}
            ${permisos.canDelete('marcas') ? `<button class="btn-icon btn-danger" title="Dar de baja" onclick="window.currentView.bajaFab(${f.id})">🗑️</button>` : ''}`}
        </td>
      </tr>`).join('');
  },

  /* ── Marcas ── */
  limpiarMarca() {
    this.data.editMarca = null;
    document.getElementById('marcaForm')?.reset();
    const cod = document.getElementById('ma_codigo');
    if (cod) cod.readOnly = false;
    document.getElementById('marcaFormTitulo').textContent = 'Nueva marca';
    document.getElementById('marcaFormCard')?.classList.remove('editando');
    document.getElementById('btnMarcaGuardar').textContent = 'Guardar marca';
  },

  editarMarca(id) {
    const m = this.data.marcas.find((x) => x.id === id);
    if (!m) return;
    this.data.editMarca = m;
    document.getElementById('marcaFormTitulo').textContent = `Editar marca ${m.nombre}`;
    document.getElementById('marcaFormCard')?.classList.add('editando');
    document.getElementById('btnMarcaGuardar').textContent = 'Guardar cambios';
    document.getElementById('ma_nombre').value = m.nombre;
    const cod = document.getElementById('ma_codigo');
    cod.value = m.codigo;
    cod.readOnly = !!m.enum_legacy;
    document.getElementById('ma_fabricante').value = m.fabricante_id || '';
    document.getElementById('ma_notas').value = m.notas || '';
    this.limpiarFab();
    this.tabs.abrirFormulario({ editando: true, etiqueta: m.nombre });
    subirAlFormulario('marcaFormCard');
  },

  async guardarMarca() {
    const nombre = val('ma_nombre');
    if (!nombre) { toast.warning('Escribe el nombre de la marca'); return; }
    const body = { nombre, fabricante_id: val('ma_fabricante') ? Number(val('ma_fabricante')) : null, notas: val('ma_notas') || null };
    const codigo = val('ma_codigo');
    try {
      if (this.data.editMarca) {
        if (!this.data.editMarca.enum_legacy && codigo && codigo.toUpperCase() !== this.data.editMarca.codigo) body.codigo = codigo;
        await catalogos.marcas.actualizar(this.data.editMarca.id, body);
        toast.success(`Marca ${nombre.toUpperCase()} actualizada`);
      } else {
        if (codigo) body.codigo = codigo;
        await catalogos.marcas.crear(body);
        toast.success(`Marca ${nombre.toUpperCase()} creada`);
      }
      this.limpiarMarca();
      this.tabs.volver();
      await this.cargar();
    } catch (err) {
      toast.error(errMsg(err));
    }
  },

  async toggleMarca(id) {
    const m = this.data.marcas.find((x) => x.id === id);
    try { await catalogos.marcas.actualizar(id, { activo: !m.activo }); toast.success(m.activo ? 'Marca desactivada' : 'Marca activada'); await this.cargar(); } catch (err) { toast.error(errMsg(err)); }
  },

  bajaMarca(id) {
    const m = this.data.marcas.find((x) => x.id === id);
    modal.confirm('Dar de baja la marca', `<p>¿Dar de baja <strong>${esc(m.nombre)}</strong>?</p><p class="text-muted">Se puede restaurar con «Ver dadas de baja».</p>`, async () => {
      try { await catalogos.marcas.eliminar(id); toast.success('Marca dada de baja'); await this.cargar(); } catch (err) { toast.error(errMsg(err)); }
    });
  },

  async restaurarMarca(id) {
    try { await catalogos.marcas.restaurar(id); toast.success('Marca restaurada'); await this.cargar(); } catch (err) { toast.error(errMsg(err)); }
  },

  /* ── Fabricantes ── */
  limpiarFab() {
    this.data.editFab = null;
    document.getElementById('fabForm')?.reset();
    document.getElementById('fabFormTitulo').textContent = 'Nuevo fabricante';
    document.getElementById('fabFormCard')?.classList.remove('editando');
    document.getElementById('btnFabGuardar').textContent = 'Guardar fabricante';
  },

  editarFab(id) {
    const f = this.data.fabricantes.find((x) => x.id === id);
    if (!f) return;
    this.data.editFab = f;
    document.getElementById('fabFormTitulo').textContent = `Editar fabricante ${f.nombre}`;
    document.getElementById('fabFormCard')?.classList.add('editando');
    document.getElementById('btnFabGuardar').textContent = 'Guardar cambios';
    document.getElementById('fa_nombre').value = f.nombre;
    document.getElementById('fa_pais').value = f.pais || '';
    document.getElementById('fa_notas').value = f.notas || '';
    this.limpiarMarca();
    this.tabs.abrirFormulario({ editando: true, etiqueta: f.nombre });
    subirAlFormulario('fabFormCard');
  },

  async guardarFab() {
    const nombre = val('fa_nombre');
    if (!nombre) { toast.warning('Escribe el nombre del fabricante'); return; }
    const body = { nombre, pais: val('fa_pais') || null, notas: val('fa_notas') || null };
    try {
      if (this.data.editFab) {
        await catalogos.fabricantes.actualizar(this.data.editFab.id, body);
        toast.success('Fabricante actualizado');
      } else {
        await catalogos.fabricantes.crear(body);
        toast.success(`Fabricante ${nombre.toUpperCase()} creado`);
      }
      this.limpiarFab();
      this.tabs.volver();
      await this.cargar();
    } catch (err) {
      toast.error(errMsg(err));
    }
  },

  async toggleFab(id) {
    const f = this.data.fabricantes.find((x) => x.id === id);
    try { await catalogos.fabricantes.actualizar(id, { activo: !f.activo }); toast.success(f.activo ? 'Fabricante desactivado' : 'Fabricante activado'); await this.cargar(); } catch (err) { toast.error(errMsg(err)); }
  },

  bajaFab(id) {
    const f = this.data.fabricantes.find((x) => x.id === id);
    modal.confirm('Dar de baja el fabricante', `<p>¿Dar de baja <strong>${esc(f.nombre)}</strong>?</p>`, async () => {
      try { await catalogos.fabricantes.eliminar(id); toast.success('Fabricante dado de baja'); await this.cargar(); } catch (err) { toast.error(errMsg(err)); }
    });
  },

  async restaurarFab(id) {
    try { await catalogos.fabricantes.restaurar(id); toast.success('Fabricante restaurado'); await this.cargar(); } catch (err) { toast.error(errMsg(err)); }
  }
};
